<div class="user-role">
    <div tabindex=0 class="user-role__card"
         [tabIndex]="otherRolesSelected ? -1 : 0"
         [ngClass]="{'selected': selectedRoles.indexOf(patientRole) > -1, 'disabled': otherRolesSelected}"
         (keyup)="onKeyUp($event, patientRole)"
         (click)="toggleRole(patientRole)">
        <mat-icon class="material-icons-round custom-icon user-role__card__icon patient-icon" svgIcon='person_fill'></mat-icon>
        <p class="user-role__card__title">{{'ROLE.PATIENT' | translate}}</p>
    </div>
    <div tabindex=0 class="user-role__card"
         [tabIndex]="patientRoleSelected ? -1 : 0"
         [ngClass]="{'selected': selectedRoles.indexOf(doctorRole) > -1, 'disabled': patientRoleSelected}"
         (keyup)="onKeyUp($event, doctorRole)"
         (click)="toggleRole(doctorRole)">
        <mat-icon class="material-icons-round custom-icon user-role__card__icon" svgIcon='doctor'></mat-icon>
        <p class="user-role__card__title">{{'ROLE.DOCTOR' | translate}}</p>
    </div>
    <div tabindex=0 class="user-role__card"
         [tabIndex]="patientRoleSelected ? -1 : 0"
         [ngClass]="{'selected': selectedRoles.indexOf(editorRole) > -1, 'disabled': patientRoleSelected}"
         (keyup)="onKeyUp($event, editorRole)"
         (click)="toggleRole(editorRole)">
        <mat-icon class="material-icons-round custom-icon user-role__card__icon" svgIcon='editor'></mat-icon>
        <p class="user-role__card__title">{{'ROLE.CONTENTEDITOR' | translate}}</p>
    </div>
    <div tabindex=0 class="user-role__card"
         [tabIndex]="patientRoleSelected ? -1 : 0"
         [ngClass]="{'selected': selectedRoles.indexOf(adminRole) > -1, 'disabled': patientRoleSelected}"
         (keyup)="onKeyUp($event, adminRole)"
         (click)="toggleRole(adminRole)">
        <mat-icon class="material-icons-round custom-icon user-role__card__icon" svgIcon='admin'></mat-icon>
        <p class="user-role__card__title">{{'ROLE.ADMIN' | translate}}</p>
    </div>
</div>
